import {CreateSubscriptionMultiStepForm} from "../multi-step-form";

export function CreateSubscriptionMultiStepFormWrapper() {
  return <CreateSubscriptionMultiStepForm />;
}
